import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/product/list.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/about",
    name: "about",
    component: () => import("../views/AboutView.vue"),
  },

  {
    //全部订单
    path: "/member/allOrderList",
    name: "member_allOrderList",
    component: () => import("../views/member/allOrderList.vue"),
    meta: { title: "全部订单" },
  },
  {
    //快速订购
    path: "/member/celerityOrder",
    name: "member_celerityOrder",
    component: () => import("../views/member/celerityOrder.vue"),
    meta: { title: "快速订购" },
  },
  {
    //收货地址
    path: "/member/shippingAddressList",
    name: "member_shippingAddressList",
    component: () => import("../views/member/shippingAddressList.vue"),
    meta: { title: "收货地址" },
  },
  {
    //我的收藏
    path: "/member/myCollect",
    name: "member_myCollect",
    component: () => import("../views/member/myCollect.vue"),
    meta: { title: "我的收藏" },
  },
  {
    //产品中心列表页
    path: "/product",
    name: "product",
    component: () => import("../views/product/list.vue"),
    meta: {
      title: "产品中心",
      keepAlive: true, // 标记列表页需要缓存
    },
  },
  {
    path: "/member/index",
    name: "index",
    component: () => import("../views/member/index.vue"),
    meta: { title: "个人中心" },
  },
  {
    //我的团队
    path: "/member/team",
    name: "team",
    component: () => import("../views/member/team.vue"),
    meta: { title: "我的团队" },
  },
  {
    //我的合同
    path: "/member/contract",
    name: "contract",
    component: () => import("../views/member/contract.vue"),
    meta: { title: "我的合同" },
  },
  {
    //我的合同详情
    path: "/member/contractdetails",
    name: "contractdetails",
    component: () => import("../views/member/contractdetails.vue"),
    meta: { title: "我的合同详情" },
  },
  {
    //我的发票
    path: "/member/invoice",
    name: "invoice",
    component: () => import("../views/member/invoice.vue"),
    meta: { title: "我的发票" },
  },
  {
    // 我的邀请
    path: "/member/invite",
    name: "invite",
    component: () => import("../views/member/invite.vue"),
    meta: { title: "我的邀请" },
  },
  {
    // 售后订单
    path: "/member/service",
    name: "service",
    component: () => import("../views/member/service.vue"),
    meta: { title: "售后订单" },
  },
  {
    //查看售后
    path: "/member/servicedetails",
    name: "servicedetails",
    component: () => import("../views/member/servicedetails.vue"),
    meta: { title: "查看售后" },
  },
  {
    //订单详情
    path: "/member/details",
    name: "details",
    component: () => import("../views/member/details.vue"),
    meta: { title: "订单详情" },
  },
  {
    path: "/product/details",
    name: "product_dets",
    component: () => import("../views/product/details.vue"),
    meta: { title: "产品详情" },
  },
  {
    //智能选型
    path: "/product/intelligentSelect",
    name: "product_intelligentSelect",
    component: () => import("../views/product/intelligentSelect.vue"),
    meta: { title: "智能选型" },
  },
  {
    //产品对比
    path: "/product/productContrast",
    name: "product_Contrast",
    component: () => import("../views/product/productContrast.vue"),
    meta: { title: "产品对比" },
  },
  {
    //购物车
    path: "/product/shoppingCart",
    name: "product_shoppingCart",
    component: () => import("../views/product/shoppingCart.vue"),
    meta: { title: "购物车" },
  },
  {
    //立即购买
    path: "/product/nowPurchase",
    name: "product_nowPurchase",
    component: () => import("../views/product/nowPurchase.vue"),
    meta: { title: "立即购买" },
  },
  {
    path: "/demo",
    name: "demo",
    component: () => import("../views/demo.vue"),
  },
  {
    // 登录
    path: "/signup/login",
    name: "login",
    component: () => import("../views/signup/login.vue"),
    meta: { title: "登录" },
  },
  {
    // 注册
    path: "/signup/register",
    name: "register",
    component: () => import("../views/signup/register.vue"),
    meta: { title: "注册" },
  },
  {
    // 忘记密码邮箱找回
    path: "/signup/forget",
    name: "forget",
    component: () => import("../views/signup/forget.vue"),
    meta: { title: "忘记密码" },
  },
  {
    // 忘记密码手机号找回
    path: "/signup/forgetphone",
    name: "forgetphone",
    component: () => import("../views/signup/forgetphone.vue"),
    meta: { title: "忘记密码" },
  },
  {
    path: "/swiperDemo",
    name: "swiperDemo",
    component: () => import("../views/swiperDemo.vue"),
  },
  {
    // 独立客服页：供同域名其他页面(企业站)通过 iframe 嵌入复用。
    // bare=true 表示纯净模式：App.vue 不渲染侧边栏/全局客服、不跑业务接口。
    path: "/customer-service",
    name: "customer_service",
    component: () => import("../views/customerWidget.vue"),
    meta: { title: "在线客服", bare: true },
  },
];

const router = new VueRouter({
  // mode: "hash",
  mode: "history",
  // base: process.env.BASE_URL,
  base: '/shop/',
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 如果通过浏览器前进/后退，则恢复到之前的位置
    if (savedPosition) {
      return savedPosition;
    }
    // 否则滚动到页面顶部
    return { x: 0, y: 0 };
  },
});

// 网站顶部title设置
router.afterEach((to) => {
  // 如果路由有 meta.title，则使用它，否则使用默认标题
  const defaultTitle = "MassLink 智链";
  document.title = to.meta.title
    ? `${to.meta.title}_${defaultTitle}`
    : defaultTitle;
});

export default router;
